export default "__VITE_ASSET__d300a401__"